import React from "react";
import ReactDOM from "react-dom";
import { Modal, Form, message } from "antd";
import FormCheckBox from "./FormCheckBox";
import { ModalProps } from "antd/es/modal";
import { getSpecialUserList, joinWithSpecialUsers } from "../service";

const EditPeopleModal = ({ onSubmit, onClose, modalProps, initData }) => {
  const [form] = Form.useForm();
  const [confirmLoading, changeConfirmLoading] = React.useState(false);
  const [visible, changeVisible] = React.useState(true);
  const [peopleData, changePeopleData] = React.useState([]);
  const loadDataList = async (record, keyWord) => {
    const res = await getSpecialUserList({
      keyWord,
      page: 1,
      pageSize: 500,
    });
    if (res && res.data) {
      changePeopleData(res.data.data);
    }
  };
  React.useEffect(() => {
    if (visible) {
      if (initData) {
        loadDataList(initData);
        form.setFieldValue(
          "spaceialUsers",
          (initData.spaceialUsers || []).map((ele) => ({
            source: ele.source,
            avatarUrl: ele.avatarUrl,
            nickName: ele.nickName,
            role: ele.role,
            openId: ele.openId,
            id: ele.id,
          }))
        );
      }
    }
  }, [visible]);
  const handleSubmit = async () => {
    const values = await form.validateFields();
    const params = {
      spaceialUsers: values.spaceialUsers.map((ele) => ({
        source: ele.source,
        avatarUrl: ele.avatarUrl,
        nickName: ele.nickName,
        role: ele.role,
        openId: ele.openId,
        id: ele.id,
      })),
      id: initData.id,
    };
    changeConfirmLoading(true);
    const res = await joinWithSpecialUsers(params);
    changeConfirmLoading(false);
    onSubmit(res);
    if (res && res.data) {
      message.success("操作成功");
      handleCancel();
    }
  };

  const handleCancel = () => {
    changeVisible(false);
    onClose();
  };
  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  };
  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
      number: "${label} is not a valid number!",
    },
    number: {
      range: "${label} must be between ${min} and ${max}",
    },
  };
  return (
    <Modal
      title="指定人员"
      visible={visible}
      onCancel={handleCancel}
      width={700}
      onOk={handleSubmit}
      confirmLoading={confirmLoading}
      {...modalProps}
    >
      <Form
        {...layout}
        name="nest-messages"
        validateMessages={validateMessages}
        form={form}
      >
        <Form.Item
          name="spaceialUsers"
          label="选择指定人员"
          rules={[{ required: false }]}
        >
          <FormCheckBox
            initData={initData}
            dataList={peopleData}
            onSearch={(keyWord) => {
              loadDataList(initData, keyWord);
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const openModal = ({ modalProps, initData } = {}) => {
  const div = document.createElement("div");
  document.body.appendChild(div);
  const onClose = () => {
    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
    }, 2);
  };
  const handleSubmit = (res) => {
    if (res.data) {
      fnSuccess && fnSuccess();
    } else {
      fnError && fnError();
    }
  };
  ReactDOM.render(
    <EditPeopleModal
      onClose={onClose}
      onSubmit={handleSubmit}
      modalProps={modalProps}
      initData={initData}
    />,
    div
  );
  let fnSubmit;
  let fnCancel;
  let fnSuccess;
  let fnError;
  const resObj = {
    cancel(fnCancel_) {
      fnCancel = fnCancel_;
      return resObj;
    },
    success(fnSuccess_) {
      fnSuccess = fnSuccess_;
      return resObj;
    },
    error(fnError_) {
      fnError = fnError_;
      return resObj;
    },
    destroy() {
      ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
    },
  };
  return resObj;
};
export default EditPeopleModal;
